import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import { getPdmApiUrl } from "@tw/shared-ui-components/lib/utils/helper";
export const getHotTopics = async () => {
  try {
    const apiUrl = getPdmApiUrl();
    const res = await axios.post(
      `/search/queryHotWords`,
      {},
      {
        baseURL: apiUrl,
      }
    );
    return res.data ? res.data.data : null;
  } catch (err) {
    console.log(err);
  }
};

export const searchSuggestions = async (text) => {
  try {
    const apiUrl = getPdmApiUrl();
    const res = axios.post(
      `/search/searchSuggestions`,
      {
        keyword: text,
      },
      {
        baseURL: apiUrl,
      }
    );
    return res.data ? res.data.data : null;
  } catch (err) {
    console.log(err);
  }
};
